/**
 * Created by razial on 22.07.2025.
 */

SceneComponent.RETAIN_SCENE_BUNDLES = false;
